import { alternarSigilo, usarSigilo } from '../lib/sigilo.ts';

/** O olho que esconde e mostra os valores da tela. */
export function BotaoSigilo({ variante = 'icone' }: { variante?: 'icone' | 'linha' } = {}) {
  const oculto = usarSigilo();

  /*
   * ⭐ **A chave do menu lateral — 14/09/2026.** O mesmo interruptor, com o
   * estado escrito ao lado: no pé do menu há espaço para dizer o que o olho
   * só insinuava.
   */
  if (variante === 'linha') {
    return (
      <button
        type="button"
        className="sigilo-linha"
        onClick={alternarSigilo}
        aria-pressed={oculto}
        title={oculto ? 'Mostrar os valores' : 'Ocultar os valores'}
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
          {oculto ? (
            <>
              <path d="M3 3l18 18" />
              <path d="M10.6 5.1A9.8 9.8 0 0 1 12 5c5 0 9 4.5 10 7a15 15 0 0 1-3 3.9" />
              <path d="M6.3 6.4C3.8 8 2.4 10.2 2 12c1 2.5 5 7 10 7a9.6 9.6 0 0 0 4.2-1" />
              <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
            </>
          ) : (
            <>
              <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
              <circle cx="12" cy="12" r="3" />
            </>
          )}
        </svg>
        <span>{oculto ? 'Valores ocultos' : 'Valores à mostra'}</span>
        <span className="sigilo-chave" aria-hidden="true" />
      </button>
    );
  }

  return (
    <button
      type="button"
      className="botao-icone"
      onClick={alternarSigilo}
      aria-pressed={oculto}
      title={oculto ? 'Mostrar os valores' : 'Ocultar os valores'}
      aria-label={oculto ? 'Mostrar os valores' : 'Ocultar os valores'}
    >
      {oculto ? (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <path d="M3 3l18 18" />
          <path d="M10.6 5.1A9.8 9.8 0 0 1 12 5c5 0 9 4.5 10 7a15 15 0 0 1-3 3.9" />
          <path d="M6.3 6.4C3.8 8 2.4 10.2 2 12c1 2.5 5 7 10 7a9.6 9.6 0 0 0 4.2-1" />
          <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      )}
    </button>
  );
}
